import { KEYS } from '../lang/keys';

export const getCreatedByLabelKey = (createdBy) => {
    const normalized = typeof createdBy === 'string' ? createdBy.toLowerCase() : '';

    if (normalized === 'user') return KEYS.CREATED_BY_USER;
    if (normalized === 'automation') return KEYS.CREATED_BY_AUTOMATION;
    if (normalized === 'schedule') return KEYS.CREATED_BY_SCHEDULE;

    return KEYS.CREATED_BY_UNKNOWN;
};
